<app-static-header></app-static-header>
<router-outlet></router-outlet>
<app-static-footer></app-static-footer>
